import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DisplayService {
  display = new BehaviorSubject<DisplayComponents>(
    new DisplayComponents(
      true, true, true, true, true
    )
  );

  public setDisplay(error: DisplayComponents): void {
    this.display.next(error);
  }

  public getDisplay(): Observable<DisplayComponents> {
    return this.display.asObservable();
  }
}

export class DisplayComponents{
  constructor(progress: boolean = true,
              title: boolean = true,
              buttonHelp: boolean = true,
              buttonExit: boolean = true,
              buttonModalChecklist: boolean = true){

    this.progress = progress;
    this.title = title;
    this.buttonHelp = buttonHelp;
    this.buttonExit = buttonExit;
    this.buttonModalChecklist = buttonModalChecklist;
  }

  progress: boolean;
  title: boolean;
  buttonHelp: boolean;
  buttonExit: boolean;
  buttonModalChecklist: boolean;
}